<div class="app-view">
  <router-outlet></router-outlet>
</div>